module.exports = __webpack_public_path__ + "static/img/200331.2280a453.png";